import { JSX } from '@stencil/core';

export abstract class OnSiteSearchModule {
  /**
   *
   * @private
   */
  protected readonly searchQuery: string;

  /**
   *
   * @private
   */
  protected readonly configuration: object;

  /**
   * key for configuration.
   */
  static CONFIGIDENTIFIER = 'OnSiteSearchModule';

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static canHandle(searchQuery: string): boolean {
    return false;
  }

  constructor(searchQuery: string, configuration: object = {}) {
    this.searchQuery = searchQuery;
    this.configuration = configuration;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getContent(context): JSX.Element {
    return null;
  }
}
